import axios from 'axios';
import { useAuthStore } from '../stores/auth.store';

// Base API client without auth
export const apiClient = axios.create({
  // check if lVITE_IS_LOCAL
  baseURL:
    import.meta.env.VITE_IS_LOCAL === 'true'
      ? import.meta.env.VITE_LOCAL_API_BASE_URL
      : import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const getToken = useAuthStore.getState().getToken;
      if (!getToken) {
        throw new Error('getToken not initialized');
      }
      const token = await getToken();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn('Could not get Auth0 token', error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      console.error('Unauthorized access:', {
        url: error.config?.url,
        status: error.response?.status,
        headers: error.config?.headers,
      });
    }
    return Promise.reject(error);
  }
);

export default apiClient;
